import React, { useMemo } from "react";
import FlowTick from "../../assets/Icons/FlowTick";
import FlowCircle from "../../assets/Icons/FlowCircle";
import FlowCircleInActive from "../../assets/Icons/FlowCircleInActive";
import OrangeDot from "../../assets/Icons/OrangeDot";

// Configuration for order progress stepper steps
const ORDER_STEPPER_STEPS = [
  {
    key: "orderValidation",
    label: "Order Validation",
    statuses: ["Assigned Request", "Order Validation"],
  },
  {
    key: "dataTriage",
    label: "Data Triage",
    statuses: ["Data Received", "Data Received Incomplete"],
  },
  {
    key: "PreparationAndValidation",
    label: "Data Preparation",
    statuses: [
      "Completeness - L1 Review",
      "Completeness - L2 Review",
      "Completeness Ready for Delivery",
      "Awaiting Completeness Confirmation",
      "Preparation & completeness in-progress",
      "Delivered completeness", //(EMEIA)
    ],
  },
  {
    key: "analyzerLoadingAndDocumentation",
    label: "Analyzer Loading",
    statuses: [
      "Analyser & Memo In Progress",
      "Analyser & memo L1 Review",
      "Analyser & memo L2 Review", //(EMEIA)
      "Analyser & Memo - Ready for Delivery",
    ],
  },
  {
    key: "finalization",
    label: "Finalization",
    statuses: ["Delivered for Onshore Review", "Delivered Analyser"],
  },
  { key: "archival", label: "Archival", statuses: ["Project Complete"] },
];

// Displays horizontal progress stepper showing order workflow stages
const OrderProgressStepper = ({ currentStatus = "" }) => {
  const steps = ORDER_STEPPER_STEPS;

  // Calculates which step is currently active based on status
  const activeStepIndex = useMemo(() => {
    if (!currentStatus) return -1;
    const stepIndex = steps.findIndex((step) =>
      step.statuses.some(
        (status) => status.toLowerCase() === currentStatus.toLowerCase(),
      ),
    );
    return stepIndex;
  }, [currentStatus, steps]);
  const stepsCount = steps.length;

  // Calculates progress ratio for the progress bar
  const progressRatio =
    activeStepIndex <= 0 ? 0 : Math.min(1, activeStepIndex / (stepsCount - 1));

  // Returns step state (completed, active, or upcoming)
  const getStepState = (stepIndex) => {
    if (activeStepIndex === -1) return "upcoming";
    if (stepIndex < activeStepIndex) return "completed";
    if (stepIndex === activeStepIndex) return "active";
    return "upcoming";
  };

  return (
    <div className="header-bottom">
      <div
        className="header-bottom-flow"
        aria-label="order-progress"
        style={{ "--steps": stepsCount, "--progress": progressRatio }}
      >
        {/* Base line (gray background) */}
        <div className="base-line" />
        {/* Progress line (colored, shows completion) */}
        <div className="progress-line" />

        {/* Render each step in the flow */}
        {steps.map((step, idx) => {
          const state = getStepState(idx);

          return (
            <div key={step.key} className={`step ${state}`}>
              <div className={`node ${state}`}>
                {state === "completed" ? (
                  <span className="check">
                    <FlowTick />
                  </span>
                ) : state === "active" ? (
                  <span className="ring">
                    <OrangeDot />
                  </span>
                ) : (
                  <FlowCircleInActive />
                )}
              </div>
              <div className="label">{step.label}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OrderProgressStepper;
